import { render, staticRenderFns } from "./FormRender.vue?vue&type=template&id=5e611c42&"
import script from "./FormRender.vue?vue&type=script&lang=js&"
export * from "./FormRender.vue?vue&type=script&lang=js&"
import style0 from "./FormRender.vue?vue&type=style&index=0&id=5e611c42&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QBtn,QScrollArea,QInnerLoading,QSpinnerIos});
